export const SEGMENT_DURATIONS = [
  { value: 30, label: '30 秒', hint: '短视频片段' },
  { value: 60, label: '60 秒', hint: '默认推荐' },
  { value: 90, label: '90 秒', hint: '中等长度' },
  { value: 180, label: '180 秒', hint: '3 分钟' },
  { value: 270, label: '270 秒', hint: '4.5 分钟' },
  { value: 360, label: '360 秒', hint: '6 分钟' },
];

export const DEFAULT_SEGMENT_DURATION = 60;

export function isValidSegmentDuration(seconds) {
  return SEGMENT_DURATIONS.some(item => item.value === Number(seconds));
}

export function getDurationHint(seconds) {
  const found = SEGMENT_DURATIONS.find(item => item.value === Number(seconds));
  return found ? found.hint : '';
}
